import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderService } from '../../../services/loader/loader.service';
import { asyncScheduler, Observable, observeOn, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-loader',
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class LoaderComponent implements OnInit, OnDestroy {
  @Input() overlay: boolean = true;

  isLoading$: Observable<boolean>;
  private destroy$ = new Subject<void>();

  constructor(private loaderService: LoaderService) {
    // A later view can start loading after this view has already been checked.
    this.isLoading$ = this.loaderService.loading$.pipe(
      observeOn(asyncScheduler),
    );
  }

  ngOnInit(): void {
    this.isLoading$.pipe(takeUntil(this.destroy$)).subscribe((loading) => {
      if (loading && this.overlay) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    document.body.style.overflow = '';
  }
}
